<template>
  <v-row>
    <v-col>
      <v-card class="mb-3">
        <v-card-text class="d-flex justify-end">
          <v-btn size="small" @click="openNewSurvey">Add Survey</v-btn>
        </v-card-text>
      </v-card>

      <data-table :tableData="tableData" :disablePagination="true">
        <template v-slot:[`item.startDate`]="{ item }">
          {{ moment(item.startDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          {{ moment(item.endDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="item.isActive ? 'success' : 'grey'" size="small">
            {{ item.isActive ? "Active" : "Inactive" }}
          </v-chip>
        </template>
        <template v-slot:[`item.Actions`]="{ item }">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" v-bind="props" size="small" variant="icon" />
            </template>
            <v-list density="compact">
              <v-list-item
                title="Edit"
                prepend-icon="mdi-pencil"
                density="compact"
                @click="editSurvey(item.surveyID)"
              />
              <v-list-item
                title="Report"
                prepend-icon="mdi-chart-bar"
                density="compact"
                @click="viewReport(item.surveyID)"
              />
              <v-list-item
                title="Preview"
                prepend-icon="mdi-eye"
                density="compact"
                @click="previewSurvey(item)"
              />
              <v-list-item
                v-if="isSurveyNotifyAvailable(item)"
                title="Send Message"
                prepend-icon="mdi-message"
                density="compact"
                @click="openSendMessage(item)"
              />
              <v-list-item
                title="Delete"
                prepend-icon="mdi-delete"
                density="compact"
                class="text-error"
                @click="deleteItem(item)"
              />
            </v-list>
          </v-menu>
        </template>
      </data-table>
    </v-col>
  </v-row>

  <NewSurveyDialog ref="dlgNewSurvey" @saved="getData" />
  <SurveyNotifyDialog
    ref="dlgNotify"
    :survey-id="notifySurveyId"
    :survey-title="notifySurveyTitle"
  />
</template>

<script setup>
import { reactive, ref, inject, onMounted } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { getAll, deleteSurvey, isSurveyNotifyAvailable } from "@/services/surveyService";
import NewSurveyDialog from "./components/NewSurveyDialog.vue";
import SurveyNotifyDialog from "./components/SurveyNotifyDialog.vue";

const loader = inject("loader");
const snackbar = inject("snackBar");
const confirmDialog = inject("confirmDialog");
const router = useRouter();

const dlgNewSurvey = ref(null);
const dlgNotify = ref(null);
const notifySurveyId = ref(null);
const notifySurveyTitle = ref("");

const tableData = reactive({
  headers: [
    { title: "S. No", key: "SNo" },
    { title: "Title", key: "title" },
    { title: "Start Date", key: "startDate" },
    { title: "End Date", key: "endDate" },
    { title: "Active", key: "isActive" },
    { title: "Responses", key: "responseCount" },
    { title: "Actions", key: "Actions" },
  ],
  data: [],
});

async function getData() {
  loader.show();
  try {
    tableData.data = await getAll();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

function openNewSurvey() {
  dlgNewSurvey.value.show();
}

function editSurvey(id) {
  router.push(`/survey-forms/${id}/edit`);
}

function viewReport(id) {
  router.push(`/survey-reports/${id}`);
}

function previewSurvey(item) {
  if (!item.isActive) {
    snackbar.error("Survey is not active");
    return;
  }
  router.push(`/survey-forms/${item.surveyID}`);
}

function openSendMessage(item) {
  notifySurveyId.value = item.surveyID;
  notifySurveyTitle.value = item.title;
  dlgNotify.value.show();
}

async function deleteItem(item) {
  const confirmed = await confirmDialog.confirm(
    "Delete Survey",
    `Delete survey "${item.title}"? This cannot be undone.`,
    "Yes",
    "No",
    true
  );
  if (!confirmed) return;

  loader.show();
  try {
    await deleteSurvey(item.surveyID);
    snackbar.success("Survey deleted");
    await getData();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

onMounted(getData);
</script>
